<template>
  <el-row>
    <el-col>
      <h1>Welcome</h1>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras eu sollicitudin tortor, nec iaculis leo. Proin quis quam arcu.</p>
      <p>Vivamus id nibh et eros scelerisque vehicula non at augue. Sed sodales velit vitae massa accumsan pharetra. Aliquam cursus maximus arcu ornare dictum. Duis urna lorem, egestas eget ornare non, tristique id nulla. Nullam sollicitudin nec enim quis elementum.</p>
    </el-col>
  </el-row>
</template>

<script>
export default {
  //
}
</script>
